import { parseNumber } from '@/helpers/validators.js'

export const price1Validation = (isFranchise, isMariaCampaign) => (value, vm) => {
  // Supercampaign allows not having both prices
  if (isMariaCampaign && !value && !vm.price_2) return true
  if (isFranchise) return true
  if (!value || value < 0) return false
  if (!vm.price_2) return value > 0
  return value >= vm.price_2
}

export const price2Validation = (isFranchise, isMariaCampaign) => (value, vm) => {
  // Supercampaign allows not having both prices
  if (isMariaCampaign && !value && !vm.price_1) return true
  if (!value || value < 0) return false
  return value <= vm.price_1
}

export const eansValidation = (eans, product) => {
  if (product.products) return true
  return eans.length
}

export const percentageDiscountValidation = (percentage_discount, product) => {
  if (!percentage_discount) return false

  return true
}

export const cashbackPercentageValidation = (percentage_discount, product) => {
  if (!percentage_discount) return false

  return true
}

export const takeAndPayValidation = (value, product) => {
  const take = parseNumber(product.take, 'int')
  const pay = parseNumber(product.pay, 'int')

  if (!take || !pay) return false

  return take > pay
}

export const minMaxPerClientValidation = (value, product) => {
  const min = product.minimum_per_client
  const max = product.maximum_per_client

  if (!min || !max) return true

  return max >= min
}

export const minMaxPerClientValidationNextbuy = (value, product) => {
  const min = product.minimum_per_client
  const max = product.max_coupons

  if (min && max) return true
  return false
}

export const distributionLimitValidation = (vm) => (value, product) => {
  if (!vm || !vm.isIntelligentDistributionEnabled) {
    return true
  }

  if (vm.campaign && vm.campaign.status === 'active') {
    return true
  }

  if (!value || value === '' || value === null || value === undefined) {
    return true
  }

  const limit = parseNumber(value, 'int')

  if (isNaN(limit) || limit < 0) {
    return false
  }

  if (limit === 0) {
    return true
  }

  let totalConsumers = 0
  if (vm.campaign && vm.campaign.segments && vm.campaign.segments.length > 0) {
    totalConsumers = vm.campaign.segments.reduce((total, segment) => {
      return total + (segment.clients_qty || 0)
    }, 0)
  }

  if (totalConsumers === 0) {
    return true
  }

  const distributionModels = vm.campaign.user_distribution_models || []
  const offersPerConsumer = distributionModels.reduce((total, model) => total + (model.quantity || 0), 0)
  const totalNeeded = totalConsumers * offersPerConsumer

  let totalAvailable = 0
  let productsWithFullSegmentLimit = 0

  const offerTypes = [
    'offer_sales',
    'percentage_offer_sales',
    'dynamic_pricing_percentage_offer_sales',
    'takepay_offer_sales',
    'combo_offer_sales',
    'cashback_percentage_offer_sales',
    'cashback_absolute_offer_sales',
    'points_offer_sales',
    'next_buy_cashback_offer_sales',
    'dynamic_rule_offer_sales',
    'cross_sell_offer_sales',
  ]

  offerTypes.forEach((type) => {
    if (vm.campaign[type] && Array.isArray(vm.campaign[type])) {
      vm.campaign[type].forEach((offer) => {
        if (offer.isGroup && offer.products && Array.isArray(offer.products)) {
          const hasActiveProducts = offer.products.some((p) => p.active)
          if (hasActiveProducts) {
            if (offer.group_rules_exhibition === 'PUBLIC') {
              const distributionLimit = offer.distribution_limit
              if (!distributionLimit || distributionLimit <= 0) {
                totalAvailable += totalConsumers
                productsWithFullSegmentLimit += 1
              } else {
                totalAvailable += distributionLimit
                if (distributionLimit >= totalConsumers) {
                  productsWithFullSegmentLimit += 1
                }
              }
            } else {
              const activeProductsCount = offer.products.filter((product) => product.active).length
              const distributionLimit = offer.distribution_limit
              if (!distributionLimit || distributionLimit <= 0) {
                totalAvailable += activeProductsCount * totalConsumers
                productsWithFullSegmentLimit += activeProductsCount
              } else {
                if (distributionLimit >= totalConsumers) {
                  totalAvailable += activeProductsCount * totalConsumers
                  productsWithFullSegmentLimit += activeProductsCount
                } else {
                  totalAvailable += activeProductsCount * distributionLimit
                }
              }
            }
          }
        } else if (offer.active) {
          const distributionLimit = offer.distribution_limit
          if (!distributionLimit || distributionLimit <= 0) {
            totalAvailable += totalConsumers
            productsWithFullSegmentLimit += 1
          } else {
            totalAvailable += distributionLimit
            if (distributionLimit >= totalConsumers) {
              productsWithFullSegmentLimit += 1
            }
          }
        }
      })
    }
  })
  if (productsWithFullSegmentLimit < offersPerConsumer) {
    return false
  }

  if (totalAvailable < totalNeeded) {
    return false
  }

  return true
}
